var systemReducer = function (items, action) {
    switch (action.type) {
        case 'SET_SYSTEM_CONFIG': {
            return action.item;
        }
        default: {
            throw Error("SystemReducer: Unhandled action ".concat(action.type));
        }
    }
};
export default systemReducer;
